<template>
  <v-dialog
    v-model="addUserDialog"
    persistent
    max-width="500px"
  >
    <add-user-form
      ref="addUserForm"
      :title="title"
      :type="type"
      :domain="domain"
      :action="action"
      :saving="saving"
      v-on="$listeners"
    />
  </v-dialog>
</template>

<script>
const AddUserForm = () => import('@/components/AddUserForm')

export default {
  name: 'AddUserDialog',
  components: { AddUserForm },
  props: {
    title: { type: String, default: '' },
    addUserDialog: { type: Boolean, default: false },
    type: { type: String, default: '' },
    domain: { type: String, default: '' },
    action: { type: String, default: '' },
    saving: { type: Boolean, default: false }
  },
  watch: {
    addUserDialog: function (addUserDialog) {
      if (addUserDialog && this.$refs.addUserForm) {
        this.$refs.addUserForm.reset()
      }
    }
  }
}
</script>
